var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGorusOneri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_693)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 9C20.4489 9 20.6397 9.07902 20.7803 9.21967C20.921 9.36032 21 9.55109 21 9.75V19.9393L19.2803 18.2197C19.1397 18.079 18.9489 18 18.75 18H9.75C9.55109 18 9.36032 17.921 9.21967 17.7803C9.07902 17.6397 9 17.4489 9 17.25V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9H20.25ZM21.841 8.15901C21.419 7.73705 20.8467 7.5 20.25 7.5H9.75C9.15326 7.5 8.58097 7.73705 8.15901 8.15901C7.73705 8.58097 7.5 9.15326 7.5 9.75V17.25C7.5 17.8467 7.73705 18.419 8.15901 18.841C8.58097 19.2629 9.15326 19.5 9.75 19.5H18.4393L21.2197 22.2803C21.4342 22.4948 21.7568 22.559 22.037 22.4429C22.3173 22.3268 22.5 22.0533 22.5 21.75V9.75C22.5 9.15326 22.2629 8.58097 21.841 8.15901Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_693",
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7843C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7983C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGorusOneri);
export default __webpack_public_path__ + "static/media/gorus-oneri.31d70124752b7a4cb09b1e45c3937fec.svg";
export { ForwardRef as ReactComponent };